import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormGroup, FormGroupLabel, ErrorMessage, RequiredMark } from './BaseInput';
import { applyMask } from './maskUtils';

const StyledMaskedInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.5;
  transition: all 0.3s;
  
  &:focus {
    outline: none;
    border-color: #1890ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
  
  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
  
  &::placeholder {
    color: #bfbfbf;
  }
`;

const MaskedInputField = ({
  name,
  label,
  placeholder,
  value,
  onChange,
  mask,
  guide = false,
  disabled = false,
  required = false,
  error,
  input,
  meta,
  ...props
}) => {
  // Usar input.value e input.onChange se disponível (React Final Form)
  const fieldValue = input ? input.value : value;
  const fieldOnChange = input ? input.onChange : onChange;
  const fieldName = input ? input.name : name;

  const handleChange = e => {
    const newValue = applyMask(e.target.value, mask);

    if (fieldOnChange) {
      fieldOnChange(newValue);
    }
  };

  return <FormGroup>
      {label && <FormGroupLabel>
          {label}
          {required && <RequiredMark>*</RequiredMark>}
        </FormGroupLabel>}
      <StyledMaskedInput name={fieldName} value={applyMask(fieldValue, mask)} onChange={handleChange} placeholder={placeholder} disabled={disabled} {...props} />
      {(error || meta && meta.touched && meta.error) && <ErrorMessage>
          {error || meta.error}
        </ErrorMessage>}
    </FormGroup>;
};

MaskedInputField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.node,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  mask: PropTypes.array,
  guide: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object
};
export default MaskedInputField;
